import CXMApiClient from "../CXMApiClient";
import EventBus from "@/lib/utilities/eventBus";
import { EventBusEvents } from "@/lib/utilities/enums";

function initialState() {
  return {
    ContactMergeStickyFooterStatus: {
      isSessionActive: false,
      IsCollapsed: false,
      sessionPlatformId: null
    },
    SelectedContactsForMerge: [],
    CurrentUserSession: [],
    ContactMergeSpinner: false
  };
}

const state = initialState();

const actions = {
  updateStickyFooterStatus: function (context, data) {
    context.commit("updateStickyFooterStatus", data);
  },
  updateSelectedContactsForMerge: function (context, data) {
    context.commit("updateSelectedContactsForMerge", data);
  },
  async getCurrentSessionForUser(context, requestPayload) {
    const cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient.ProcessRequest(
      "POST",
      "/api/contact/merge/get_current_session",
      requestPayload
    ).catch(err => err.response);

    if (response && response.data && response.data.successful && response.data.data) {
      context.commit("updateCurrentUserSession", response.data.data);
      return response.data.data;
    }

    return null;
  },
  async createSession(context, payload) {
    const cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient.ProcessRequest(
      "POST",
      "/api/contact/merge/create_session",
      payload
    ).catch(err => err.response);

    if (response && response.data && response.data.successful)
      context.commit(
        "updateCurrentUserSession",
        response.data && response.data.successful && response.data.data
          ? response.data.data
          : null
      );

    return response;
  },
  async addContactToSession(context, payload) {
    const cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient.ProcessRequest(
      "POST",
      "/api/contact/merge/add_contact_to_session",
      payload
    ).catch(err => err.response);

    if (response && response.data && response.data.successful)
      context.commit(
        "updateCurrentUserSession",
        response.data && response.data.successful ? response.data.data : null
      );

    return response;
  },
  async removeContactFromSession(context, payload) {
    const cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient.ProcessRequest(
      "POST",
      "/api/contact/merge/remove_contact_from_session",
      payload
    ).catch(err => err.response);

    if (response && response.data && response.data.successful)
      context.commit(
        "updateCurrentUserSession",
        response.data && response.data.successful ? response.data.data : null
      );

    return response &&
      response.data &&
      response.data.successful &&
      response.data.data
      ? response.data
      : null;
  },
  async deleteMergeSession(context, request) {
    const cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient.ProcessRequest(
      "POST",
      "/api/contact/merge/delete_session",
      {
        accountPlatformId: request.platformId
      }
    ).catch(err => err.response);

    // Clear dock if the user has invalid data
    if (response && response.data && (response.data.successful || response.data.statusCode == 404)) {
      if (!request.isSilent)
        EventBus.$emit(EventBusEvents.HelperFunctionSnotifyNotification, {
          message: "Contact merge session has been deleted successfully",
          success: true
        });
      context.commit("updateCurrentUserSession", null);
      context.commit("updateSelectedContactsForMerge", []);
      context.dispatch("updateStickyFooterStatus", {
        isCollapsed: false,
        isSessionActive: false,
        sessionPlatformId: null,
      });
      return response.data;
    }

    return null;
  },
  async simulateMergeSession(context, requestPayload) {
    const cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient.ProcessRequest(
      "POST",
      "/api/contact/merge/simulate",
      requestPayload
    ).catch(err => err.response);

    return response && response.data && response.data.successful
      ? response.data
      : null;
  },
  async executeMergeSession(context, requestPayload) {
    const cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient.ProcessRequest(
      "POST",
      "/api/contact/merge/execute",
      requestPayload
    ).catch(err => err.response);

    if (response && response.data && response.data.successful) {
      context.commit("updateCurrentUserSession", null);
      context.commit("updateSelectedContactsForMerge", []);
      return response.data.data;
    } else return null;
  },
  async getDriversLicenseFrontImage(context, contactId) {
    const cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient
      .ProcessBlobRequest(
        "GET",
        `/crm/contacts/${contactId}/driver_license_front`
      )
      .catch(ex => {
        return null;
      });
    return response;
  },
  async getDriversLicenseBackImage(context, contactId) {
    const cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient
      .ProcessBlobRequest(
        "GET",
        `/crm/contacts/${contactId}/driver_license_back`
      )
      .catch(ex => {
        return null;
      });
    return response;
  },
  async getDriversLicenseAvatar(context, contactId) {
    const cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient
      .ProcessBlobRequest(
        "GET",
        `/crm/contacts/${contactId}/driver_license_avatar`
      )
      .catch(ex => {
        return null;
      });
    return response;
  },
  updateContactMergeSpinner: function (context, data) {
    context.commit("updateContactMergeSpinner", data);
  }
};

const mutations = {
  updateStickyFooterStatus: function (state, data) {
    state.ContactMergeStickyFooterStatus = data;
  },
  updateSelectedContactsForMerge: function (state, data) {
    state.SelectedContactsForMerge = data;
  },
  updateCurrentUserSession: function (state, data) {
    state.CurrentUserSession = data;
  },
  updateContactMergeSpinner: function (state, data) {
    state.ContactMergeSpinner = data;
  }
};

const getters = {
  SelectedContactsForMerge: function (state) {
    return state.SelectedContactsForMerge;
  },
  CurrentUserSession: function (state) {
    return state.CurrentUserSession;
  },
  ContactMergeSpinner: function (state) {
    return state.ContactMergeSpinner;
  },
  ContactMergeStickyFooterStatus: function () {
    return state.ContactMergeStickyFooterStatus;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/ContactMerge.js